module.exports = __webpack_public_path__ + "img/six.38c58c5c.jpg";